import { render } from "./demo-ai-tree-node-load1.vue?vue&type=template&id=e27bd8fc"
import script from "./demo-ai-tree-node-load1.vue?vue&type=script&setup=true&lang=js"
export * from "./demo-ai-tree-node-load1.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/demo/demo-ai-tree-node-load1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e27bd8fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e27bd8fc', __exports__)) {
    api.reload('e27bd8fc', __exports__)
  }
  
  module.hot.accept("./demo-ai-tree-node-load1.vue?vue&type=template&id=e27bd8fc", () => {
    api.rerender('e27bd8fc', render)
  })

}


export default __exports__